export default __webpack_public_path__ + "static/1-dac7d800f87fef218ef7bb1ad8393844.jpeg";